import { dependencies } from '@pn/core/dependencies';
import type { StockInfo } from '@pn/core/domain/intel/intel';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { isNil } from 'lodash-es';
import { realTimeStockSlice } from './realTimeStockSlice';

export const useRealTimeStockStorage = () => {
  const { name, getInitialState } = realTimeStockSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isFetching: useSliceSelector((state) => state.isFetching),
    isError: useSliceSelector((state) => state.isError),
    stock: useSliceSelector((state) => state.stock),
  };
};
export const realTimeStockActions = () => {
  const { dispatch, getState } = dependencies.store;
  const { actions, name } = realTimeStockSlice;

  if (isNil(getState()[name])) {
    throw new Error(`[${name}] reducer has not been injected yet`);
  }

  return {
    request: () => dispatch(actions.request()),
    receive: (company: StockInfo) => dispatch(actions.receive(company)),
    error: () => dispatch(actions.error()),
    reset: () => dispatch(actions.reset()),
  };
};
